import { call, put, select } from 'redux-saga/effects';
import {
  previewFileClosed,
  selectPreviewedFile,
} from 'features/content-library/contentLibrarySlice';
import { ContentLibraryOpenedFile } from 'features/content-library/types';
import { requestActivePanelWhiteboardDataSaga } from 'features/content-whiteboard/sagas/requestActivePanelWhiteboardDataSaga';
import { SignalingSocket } from 'services/signaling';

export function* closePreviewContentLibraryFileSaga() {
  const previewFile: ContentLibraryOpenedFile | null = yield select(selectPreviewedFile);

  if (!previewFile) {
    return;
  }

  yield put(previewFileClosed());

  yield call(SignalingSocket.send, {
    event: previewFile.type === 'whiteboard' ? 'closeWhiteboard' : 'closeLibraryFile',
    data: { id: previewFile.id },
  });

  yield call(requestActivePanelWhiteboardDataSaga);
}
